<template>
  <b-container class="pb-5 bv-example-row">
    <b-row>
      <!-- NOTE: Include the other student informtion at the top of this page -->
      <b-col><img alt="mySchool" src="@/assets/mySchoolLogo300x502.png" class="w-100 logo"></b-col>
    </b-row>
    <b-row>
      
    </b-row>
    <!-- NOTE: This page should fit a standard piece of paper, landscape. (11x8.5) so the day colums can be wide enough to handle the 
               complete description, i'm guessing
     -->
    <b-row v-if="studentDetails">
      <b-col sm="8" class="student-info">Name: {{ studentDetails.alias }}<br />Grade: {{ studentDetails.grade }}<br />Teacher: {{ studentDetails.teacher }} </b-col>
      <b-col sm="2" class="text-right non-printable align-self-end" v-if="step == 2">
        <button class="btn btn-outline-primary" @click="back()">BACK</button>
      </b-col>
      <b-col sm="2" class="text-right non-printable align-self-end" v-if="step == 2">
        <button class="btn btn-outline-primary" @click="print('printable')">PRINT</button>
      </b-col>
    </b-row>
    <b-row v-if="step==1" class="mt-4">
      <b-col>
        <!--<date-picker 
          @setDate="setDate" :selectedDate="selectedDate.iso"/> -->
          <sweet-calendar
            :eventCategories="eventCategories"
            :events="events"
            cursor="pointer"
            :highlightSelectDate="true"
            :highlightWeek="true"
            :showNextPrevMonthDays="true"
            eventCursor="crosshair"
            @click="selectDay($event)"
            ref="calendar"
          />
          <!--:initialDate="calendar.calendarStartDate"
            :beginDate="calendar.calendarStartDate"
            :endDate="calendar.calendarEndDate"-->
      </b-col>
    </b-row>
    <b-row v-if="step==1" class="float-right mb-4">
      <b-col>
        <button class="btn btn-outline-primary" @click="getOrders()" :disabled="!selectedDate">View Orders For Day {{moment(selectedDate).format( "DD")}}</button>
      </b-col>
    </b-row>
    <b-row class="px-3 mt-2" v-if="step==2">
      <OrderCalendarCard v-for="(order,key) in sortOrders" :orderKey="key" :key="key" :order="order" />
    </b-row>
  </b-container>
</template>

<script>
// @ is an alias to /src
import Moment from "moment"
import OrderCalendarCard from '@/components/OrderCalendarCard.vue'
import SweetCalendar from '@/components/Calendar.vue'
import 'vue-sweet-calendar/dist/SweetCalendar.css'

export default {
  name: 'orderCalendar',
  components: {
    OrderCalendarCard,
    SweetCalendar
  },
  computed: {
    sortOrders() {
      let sortData = {};
      this.days.map((day, key) => {
        sortData[day] = null
      })
      this.orders.map((order, key) => {
        sortData[Moment(order.orderDate).format("ddd")] = order
      })
      return sortData
    },
    studentDetails() {
      if(this.orders.length > 0) {
        return {
          "alias": this.orders[0].alias,
          "grade": this.orders[0].grade,
          "teacher": this.orders[0].teacher
        }
      } else {
        return null
      }
    }
  },
  data() {
    return {
      eventCategories: [
        {
          id: 1,
          title: 'Personal',
          textColor: 'white',
          backgroundColor: 'Blue'
        },
        {
          id: 2,
          title: 'Company-wide',
          textColor: 'white',
          backgroundColor: 'red'
        }
      ],
      events: [
        {
          title: 'Event 1',
          start: '2019-04-02',
          end: '2019-04-04',
          repeat: 'monthly',
          categoryId: 1
        },
        {
          title: 'Event 2',
          start: '2019-04-08',
          end: '2019-04-09',
          repeat: 'yearly',
          categoryId: 1
        },
        {
          title: 'Event 3',
          start: '2019-04-10',
          end: '2019-04-11',
          repeat: 'never',
          categoryId: 2
        },
        {
          title: 'Event 4',
          start: '2019-04-23',
          end: '2019-04-23',
          repeat: 'monthly',
          categoryId: 2
        }
      ],
      step : 1,
      selectedDate: null,
      // NOTE:
      //    The accountNumber and badgeNumber don't mean anything to the parent
      //  DeliverDate: will always be null 

      //    alias = student name          <-- these 3 fields will be the same for ALL orders in this listing
      //    grade = student grade level
      //    teacher = student's teacher

      //    calendarNumber is the calendar from which this order was placed but no value for the parent to know
      //  orderNumber - no value for the parent; internal use
      //    orderType will always be "meal"
      //  title will not have any useful data; items.title is the name of the menu item sold, however.
      //    items.priceLevel is for internal use
      //    items.isOverride is for internal use (means someone changed the title from the master list -- no value to the parent to know)
      //    items.qty * items.price = total for this item.
      //    item.itemType will always be 'item' for meal orders here...
      //    created and updated dates have no value for the parent
      //    __v for internal use
      // step: 1,
      // calendarLimit : {min: Moment().format('D/M/YYYY'), max: Moment().add(1, 'month').format('D/M/YYYY')},
      // markedDatesArr: ["5/9/2019", "6/9/2019"],
      // cartValue: [],
      // calendarData: {},
      // orderList: {},
      days: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'],
      // products: [{
      //     "isOverride": false,
      //     "taxable": false,
      //     "itemNumber": 1126,
      //     "itemCategory": "meal",
      //     "itemType": "item",
      //     "title": "Cheesy Beef Macaroni",
      //     "priceLevel": 1,
      //     "description": "Cheesy Beef Macaroni \nCarrots\nBiscuit\nFruit\n",
      //     "qty": 2,
      //     "price": 3.75,
      //     "_id": "5d6b3f875be6216ebc3195a2"
      //   },
      //   {
      //     "isOverride": false,
      //     "taxable": false,
      //     "itemNumber": 1301,
      //     "itemCategory": "drinks",
      //     "itemType": "item",
      //     "title": "Fruit Juice",
      //     "priceLevel": 0,
      //     "description": "",
      //     "qty": 1,
      //     "price": 0.75,
      //     "_id": "5d6b3f875be6216ebc3195a1"
      //   },
      //   {
      //     "isOverride": false,
      //     "taxable": false,
      //     "itemNumber": 1401,
      //     "itemCategory": "always",
      //     "itemType": "item",
      //     "title": "Applesauce Cup",
      //     "priceLevel": 0,
      //     "description": "Unsweetened Applesauce",
      //     "qty": 3,
      //     "price": 1,
      //     "_id": "5d6b3f875be6216ebc3195a0"
      //   }
      // ],
      orders: []
    }
  },
  methods: {
    moment(d) {
      return Moment(d, "DD-MM-YYYY")
    },

    print(divName) {
      window.print();
    },

    getOrders () {
      /* will call api here for get orders by date*/
      this.orders = [{
          "orderType": "meal",
          "orderNumber": 108312248237360,
          "calendarNumber": "July-2019-23126",
          "accountNumber": "SID-190710152780021",
          "badgeNumber": "1201046",
          "alias": "Sandy Bailey",
          "grade": "8",
          "teacher": "Mr. Wolf Scott",
          "title": "",
          "deliverDate": null,
          "total": 5.5,
          "subtotal": 0,
          "tax": 0,
          "_id": "5d6b3f875be6216ebc31959f",
          "items": [{
              "isOverride": false,
              "taxable": false,
              "itemNumber": 1126,
              "itemCategory": "meal",
              "itemType": "item",
              "title": "Cheesy Beef Macaroni",
              "priceLevel": 1,
              "description": "Cheesy Beef Macaroni \nCarrots\nBiscuit\nFruit\n",
              "qty": 1,
              "price": 3.75,
              "_id": "5d6b3f875be6216ebc3195a2"
            },
            {
              "isOverride": false,
              "taxable": false,
              "itemNumber": 1301,
              "itemCategory": "drinks",
              "itemType": "item",
              "title": "Fruit Juice",
              "priceLevel": 0,
              "description": "",
              "qty": 3,
              "price": 0.75,
              "_id": "5d6b3f875be6216ebc3195a1"
            },
            {
              "isOverride": false,
              "taxable": false,
              "itemNumber": 1401,
              "itemCategory": "always",
              "itemType": "item",
              "title": "Applesauce Cup",
              "priceLevel": 0,
              "description": "Unsweetened Applesauce",
              "qty": 1,
              "price": 1,
              "_id": "5d6b3f875be6216ebc3195a0"
            }
          ],
          "orderDate": "2019-09-02T13:00:00.000Z",
          "createdAt": "2019-09-01T03:48:23.326Z",
          "updatedAt": "2019-09-01T03:48:23.326Z",
          "__v": 0
        },
        {
          "orderType": "meal",
          "orderNumber": 108312334561766,
          "calendarNumber": "July-2019-23126",
          "accountNumber": "SID-190710152780021",
          "badgeNumber": "1201046",
          "alias": "Sandy Bailey",
          "grade": "8",
          "teacher": "Mr. Wolf Scott",
          "title": "",
          "deliverDate": null,
          "total": 5.25,
          "subtotal": 0,
          "tax": 0,
          "_id": "5d6b4a701d47813d245906dc",
          "items": [{
              "isOverride": false,
              "taxable": false,
              "itemNumber": 1139,
              "itemCategory": "meal",
              "itemType": "item",
              "title": "Crispy Chicken Sandwich",
              "priceLevel": 1,
              "description": "Crispy Chicken Sand\nWhole Wheat Bun\nSweet Potato Fries\nVegetable\nFruit\n",
              "qty": 1,
              "price": 3.75,
              "_id": "5d6b4a701d47813d245906df"
            },
            {
              "isOverride": false,
              "taxable": false,
              "itemNumber": 1301,
              "itemCategory": "drinks",
              "itemType": "item",
              "title": "Fruit Juice",
              "priceLevel": 0,
              "description": "",
              "qty": 4,
              "price": 0.75,
              "_id": "5d6b4a701d47813d245906de"
            },
            {
              "isOverride": false,
              "taxable": false,
              "itemNumber": 1403,
              "itemCategory": "always",
              "itemType": "item",
              "title": "Chips",
              "priceLevel": 0,
              "description": "",
              "qty": 2,
              "price": 0.75,
              "_id": "5d6b4a701d47813d245906dd"
            }
          ],
          "orderDate": "2019-09-05T13:00:00.000Z",
          "createdAt": "2019-09-01T04:34:56.764Z",
          "updatedAt": "2019-09-01T04:34:56.764Z",
          "__v": 0
        }
      ]
      this.step += 1;
    },

    back() {
      this.step -= 1;
    },
    
    selectDay(day) {
      this.selectedDate = day

    }
  }
}
</script>
<style lang="scss">
@media print {
  @page  
  { 
    size: landscape;   /* auto is the initial value */ 

    /* this affects the margin in the printer settings */ 
    margin: 25mm 25mm 25mm 25mm;  
  } 

  .logo {
    width: 300px !important;
    max-width: 300px !important;
  }

  .non-printable, #nav {
    display: none;
  }

  .container {
    width: 100%;
    max-width: 100%;
  }

  .col-bg.width-20 {
    max-width: 20%;
    width: 20%;
    flex: 0 0 20%;
    border: 1px solid rgba(0, 0, 0, .5);;
    border-right: none;
  }

  .col-bg.width-20:last-child {
    border-right: 1px solid rgba(0, 0, 0, .5);;
  }

  .week-title {
    color: #333 !important;
    border: none;
    border-bottom: 1px solid rgba(0, 0, 0, .5);
  }
 
  .week-content .item-detail {
    border-color: rgba(0, 0, 0, .5) !important;
  }
}

/* style sheet for "letter" printing */
@media print and (width: 8.5in) and (height: 11in) {
  @page {
      margin: 1in;
  }
}

.logo {
  max-width: 500px;
}

.student-info {
  font-size: 20px;
  text-align: left;
  @media only screen and (max-width: 574px) {
    margin-top: 20px;
  }
}

.btn-outline-primary {
  color: rgb(31,177,133);
  border-color: rgb(31,177,133);
  min-width: 130px;
}

.btn-outline-primary:not(:disabled):not(.disabled):active,
.btn-outline-primary:hover,
.btn-outline-primary:active {
  background-color: rgb(31,177,133);
  border-color: rgb(31,177,133);
  
}

.btn-outline-primary:focus, .btn-outline-primary.focus {
  box-shadow: 0 0 0 0.2rem rgba(31,177,133, 0.5) !important;
}

// See the OrderCalendarCard for info on the day color numbers
.week-title {
  padding-bottom: 10px; 
  padding-top: 10px; 
  font-weight: 600;
  font-size: 15px;
  &.monday {
    background: rgb(237,50,55);
    color: #fff;
  }
  &.tuesday {
    background: rgb(57,166,194);
    color: #fff;
  }
  &.wednesday {
    background: rgb(94,54,150);
    color: #fff;
  }
  &.thursday {
    background: rgb(31,177,133);
    color: #fff;
  }
  &.friday {
    background: rgb(127,184,71);
    color: #fff;
  }
}

.week-title ~ .week-title {
  padding-bottom: 10px; 
  padding-top: 10px; 
  font-weight: 600;
  font-size: 15px;
}

</style>